import {
  withFormsy,
} from 'formsy-react';

import InputDateView from './InputDateView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputDateView);

const Component = InputComponent;

export default Component;
